// ตัวกรองของตารางประวัติ: กรองตามสถานะของประกัน (ไม่ใช่ช่วงวันที่แล้ว)
// ว่าง = ACTIVE ตามสเปก API แต่ตั้งค่าเริ่มต้นไว้ชัดเจนให้ dropdown แสดงตัวเลือกที่เลือกอยู่
export const WARRANTY_EXPIRY_FILTER = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  ALL: 'ALL',
};

export const FORM_CUSTOMER_HISTORY_FILTER = [
  {
    name: 'expired',
    label: 'สถานะประกัน',
    type: 'DROPDOWN',
    span: 8,
    properties: {
      options: [
        { value: WARRANTY_EXPIRY_FILTER.ACTIVE, label: 'ไม่หมดอายุ' },
        { value: WARRANTY_EXPIRY_FILTER.EXPIRED, label: 'หมดอายุ' },
        { value: WARRANTY_EXPIRY_FILTER.ALL, label: 'ทั้งหมด' },
      ],
    },
  },
];

export const customerHistoryFilterDefaultValues = () => ({
  expired: WARRANTY_EXPIRY_FILTER.ACTIVE,
});
